import * as React from 'react';
import parse from 'html-react-parser';

import { Tooltip, pluralize, getSmallIconForActivityClassification, EVIDENCE } from '../../../Shared/index'
import { TEKS_COURSE_PAGE, TEKS_PREMIUM_TOOLTIP_TEXT } from '../../constants/contentHubs';
import { SPONSORED_SUBSCRIPTION_TYPES } from '../../components/subscriptions/constants'

const assetLink = (link, name) => (<a href={link} rel="noopener noreferrer" target="_blank">{name}</a>)

const CoursePageActivity = ({ activity, courseType, subscriptionType }) => {
  const {
    activity_type,
    display_name,
    description,
    paired_oer_asset_name,
    paired_oer_asset_link,
    paired_fishtank_lesson_name,
    paired_fishtank_lesson_link,
    assigned_student_count,
    completed_student_count,
    link_for_report,
    average_score,
    preview_href,
    paired_ai_edu_activities,
  } = activity

  const renderPieChart = () => {
    const rawPercent = completed_student_count / assigned_student_count;
    const percent = rawPercent > 100 ? 100 : Math.round(rawPercent * 100) / 100;
    const largeArcFlag = percent > 0.5 ? 1 : 0;
    const pathData = `M 1 0 A 1 1 0 ${largeArcFlag} 1 ${Math.cos(2 * Math.PI * percent)} ${Math.sin(2 * Math.PI * percent)} L 0 0`;
    return (
      <svg className="course-page-pie-chart" viewBox="-1 -1 2 2">
        <path d={pathData} fill="#348fdf" />
      </svg>
    );
  }

  const renderPairedActivityLinks = (pairedActivities) => {
    const activityLinks = pairedActivities.map(({ name, link, }) => {
      return assetLink(link, name)
    })

    if (activityLinks.length === 1) {
      return activityLinks
    }

    activityLinks.splice(1, 0, ' and ')

    return activityLinks
  }

  function activityIcon() {
    const activityType = activity_type || EVIDENCE
    return getSmallIconForActivityClassification(activityType)
  }

  function viewResultsButton() {
    if(courseType === TEKS_COURSE_PAGE && !SPONSORED_SUBSCRIPTION_TYPES.includes(subscriptionType)) {
      return(
        <Tooltip
          tooltipText={TEKS_PREMIUM_TOOLTIP_TEXT}
          tooltipTriggerText={<button className="quill-button small contained disabled focus-on-light" disabled={true} type="button"><img alt="" src="https://assets.quill.org/images/icons/xs/lock.svg" /> View results</button>}
        />
      )
    }
    return <a className="quill-button focus-on-light small contained green" href={link_for_report}>View results</a>
  }

  let resultsSection = (
    <div className="results-section">
      <Tooltip
        tooltipText="There are no assigned activities. Once activities are assigned and completed, you can view results."
        tooltipTriggerText={<button className="quill-button focus-on-light small contained disabled" disabled={true} type="button">View results</button>}
      />
    </div>
  )

  if (link_for_report) {
    resultsSection = (
      <div className="results-section">
        {viewResultsButton()}
        <p>{renderPieChart()} {completed_student_count} of {assigned_student_count} student{assigned_student_count === 1 ? '' : 's'} completed</p>
        {average_score !== null && <p>Average score: {average_score}%</p>}
      </div>
    )
  }

  return (
    <section aria-label={display_name} className="course-page-activity">
      {activityIcon()}
      <div className="activity-information">
        <h5>{preview_href ? <a href={preview_href} rel="noopener noreferrer" target="_blank">{parse(display_name)}</a> : parse(display_name)}</h5>
        <p>{parse(description)}</p>
        {paired_oer_asset_link && paired_oer_asset_name && (
          <p className="asset-line"><span>Optional Paired OER Project Activity:</span> {assetLink(paired_oer_asset_link, paired_oer_asset_name)}</p>
        )}
        {paired_fishtank_lesson_name && (
          <p className="asset-line"><span>Paired Fishtank ELA Lesson:</span> {paired_fishtank_lesson_link ? assetLink(paired_fishtank_lesson_link, paired_fishtank_lesson_name) : paired_fishtank_lesson_name}</p>
        )}
        {paired_ai_edu_activities?.length && (
          <p className="asset-line"><span>Optional Paired aiEDU {pluralize(paired_ai_edu_activities.length, 'Activity', 'Activities')}:</span> {renderPairedActivityLinks(paired_ai_edu_activities)}</p>
        )}
      </div>
      {resultsSection}
    </section>
  )
}

export default CoursePageActivity
